import React from 'react';

import style from './AIGenerationDashboard.module.css';

import AIGenerationStatusView from './AIGenerationStatus';

class AIGenerationDashboardView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {	};
	}

	componentDidMount() {
		const {
			app,
			accountUUID,
			systemGroupUUID,
		} = this.props;

		app.fetchAccount(accountUUID, systemGroupUUID);
	}

	render() {
		const {
			app,
			accountUUID,
			fd,
		} = this.props;

		return (
			<React.Fragment>
				<div className={`systems-page fade-in`}>
					<div className={style.pageHeader}>
						<h2>AI Generation Dashboard</h2>
					</div>

					<AIGenerationStatusView
						app={app}
						fd={fd}
						accountUUID={accountUUID}
					/>

				</div>
			</React.Fragment>
		);
	}
}

export default AIGenerationDashboardView;